import { atomicwarType, prefix, urls } from 'utils/url';
import { atomicwarHost, pveHost, lordWarHost, lwPayserver, partyHost, p5Host,luckdefenceHost } from './hosts';
import * as actionTypes from 'actions';
import store from 'globalstore.js';
import { lordWarPrefix, lordWarType } from './lordwarURL';
import {payServerType,payserverHost}from './payurls';
import { pveType, pvePrefix } from './pveUrl';
import { partyPrefix, partyType } from './partyUrl';
import { p5Prefix,p5Type } from './p5URL';
import { luckyprefix, luckytype } from './luckydefene';

const AuthFetch = (uri, data, method, type = "") => {
    var url = "";
    if (type == atomicwarType || type == "") {
        url = atomicwarHost + prefix + uri;
    } else if (type == pveType) {
        url = pveHost + pvePrefix + uri;
    } else if (type == lordWarType) {
        url = lordWarHost + lordWarPrefix + uri;
    } else if (type == payServerType) {
        url = payserverHost + uri
    } else if (type == partyType) {
        url = partyHost + partyPrefix + uri;
    } else if (type == p5Type){
        url = p5Host  + p5Prefix + uri;
    } else if (type == luckytype){
        url = luckdefenceHost  + luckyprefix + uri;
    } else {
        console.log("invalid type:" + type)
        return
    }
    console.log(url);
    if (method == "GET") {
        return fetch(url, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.token1,
                'Content-Type': 'application/json',
            }
        }).then((resp) => resp.json()).then(data => {
            let promise = new Promise(function (resolve, reject) {
                if (data != null && data.Status != null) {
                    if (data.Status.Code == 1) {
                        resolve(data);
                    } else if (data.Status.Code == 20000) {
                        RefreshLogin();
                    } else {
                        reject();
                    }
                }

            });
            return promise;
        }
        );
    }
    return fetch(url, {
        method: method,
        mode: 'cors',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.token1
        }
    }).then((resp) => resp.json()).then(data => {
        let promise = new Promise(function (resolve, reject) {
            if (data != null && data.Status != null) {
                if (data.Status.Code == 1) {
                    resolve(data);
                } else if (data.Status.Code == 20000) {
                    RefreshLogin();
                } else {
                    reject();
                }
            }

        });
        return promise;
    }
    );
}

export const RefreshLogin = () => {
    let url = atomicwarHost + prefix + urls.refresh.path;
    let postData = { "refreshToken": localStorage.token2 };
    fetch(url, {
        method: "POST",
        mode: 'cors',
        body: JSON.stringify(postData),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((resp) => resp.json()).then(rv => {
        let data = rv.Data;
        localStorage.atom = JSON.stringify(data);
        localStorage.token1 = data.authToken;
        localStorage.token2 = data.refreshToken;
        actionTypes.login(data)(store.dispatch);
    }
    );
}
export default AuthFetch;
